import React, { useContext } from 'react';
import { ChatbotContext } from '../contexts/ChatbotContext';
import { joinClassnames } from '../utils';
import { INITIAL_CHATBOT_MESSAGE } from './config';
import { GMAMarkdown } from '../components/GMAMarkdown';
import { APIContext } from '../contexts/APIContext';

const CustomChatMessage = (props: any) => {
  // Gather message from props (message is the chatResponse object)
  const { message } = props;

  // Gather selectedResponseId from chatbotcontext
  const {
    selectedResponseId,
    setSelectedResponseId,
    setFetchChatHistoryFlag,
    setIsPromptCancelling,
    isPromptCancelling,
    instanceId,
    closeRef,
    showCancelButton,
    setShowCancelButton,
  } = useContext(ChatbotContext);
  const { chatResponse } = useContext(APIContext);
  // Response Id from chatResponse - the first (default) message will not have a response ID
  const responseId: string = message && message.responseId ? message.responseId : 'initial';

  const parsedResponse: any =
    typeof chatResponse === 'object' && (chatResponse as any)?.stepResponse ? chatResponse : undefined;
  setShowCancelButton(
    parsedResponse?.stepResponse
      ? instanceId &&
          !(
            parsedResponse?.stepResponse?.currentStep === 'Save Response' ||
            parsedResponse?.stepResponse?.currentStep === 'Process Response'
          )
      : parsedResponse === undefined
      ? false
      : true
  );

  // Set the selectedResponseId when message is clicked
  const handleChatMessageClick = () => {
    setFetchChatHistoryFlag(false);
    setSelectedResponseId(responseId);
  };

  // Determine if this message is selected
  const isSelected = selectedResponseId === responseId;
  /* Used to show loading icon when prompt is generating with needed width
  could be removed in future, if not needed
  */
  // useEffect(() => {
  //   const loadingDiv = document.getElementById('prompt-loader-icon-container');
  //   if (loadingDiv) {
  //     const parentDiv = loadingDiv.parentElement?.parentElement;
  //     if (parentDiv) {
  //       parentDiv.classList.add('prompt-loader');
  //     }
  //   }
  // }, [isPromptGenerating]);
  console.log('showCancelButton', showCancelButton);
  return (
    <>
      <div
        id={`response-${responseId}`}
        className={joinClassnames(
          responseId === 'initial' ? '' : 'cursor-pointer hover:!bg-gamma-grey-hover',
          isSelected ? '!bg-gamma-grey' : '!bg-gamma-grey',
          'react-chatbot-kit-chat-bot-message'
        )}
        onClick={responseId === 'initial' ? () => undefined : handleChatMessageClick}
      >
        {/* show loading message if message is "Great! Let me think..." */}
        {message === 'Great! Let me think...' ? (
          // <p>{message}</p>
          <div className="w-full flex justify-between">
            <div className="pt-1" id="prompt-loader-icon-container">
              <img width="24" height="24" src="/icons/loading.gif" alt="bot icon" />
            </div>
            {showCancelButton && (
              <div
                id="stop-response-container"
                className={`cursor-pointer mr-4 ${isPromptCancelling && 'not-clickable'}`}
                onClick={() => setIsPromptCancelling(true)}
                ref={closeRef}
              >
                <img width="16" height="16" src="/icons/Close.svg" alt="stop icon" />
              </div>
            )}
          </div>
        ) : message === INITIAL_CHATBOT_MESSAGE ? (
          // show initial message if responseId is initial or message matches INITIAL_CHATBOT_MESSAGE in the chat config.js file
          INITIAL_CHATBOT_MESSAGE
        ) : (
          // Normal message
          <GMAMarkdown markdown={message.text} />
        )}
      </div>
    </>
  );
};

export default CustomChatMessage;
